import React from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import dayjs from "dayjs"
import colors from "../../Constants/colors"

import PYPLayoutContainer from "../PYPLayoutContainer/PYPLayoutContainer.js"
import PYPPartTitleContent from "../PYPPartTitleContent/PYPPartTitleContent.js"
import Actions from "../../Redux/Actions"
import TimeConstraintSelector from "../TimeConstraintSelector/TimeConstraintSelector"

const styles = {
  constraintsContainer: {
    color: colors.midnight,
    width: "80%",
    marginLeft: "auto",
    marginRight: "auto",
    marginTop: "150px",
    maxWidth: "800px",
    display: "flex",
    flexDirection: "row",
    flexWrap: "wrap"
  },
  layoutContainer: {
    justifyContent: "start"
  },
  startingConstraint: {
    width: "250px",
    marginRight: "auto"
  },
  endingConstraint: {
    width: "250px"
  }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(Actions, dispatch)
}

const mapStateToProps = (state, props) => {
  const currentPart = state.pyp?.parts?.byId?.[state.pyp?.navigation?.currentPartId]
  const partDataId = currentPart?.partData

  let metadata = { title: null, description: null }
  let constraints = []
  let calender = false

  // The partData will get fetched separately
  const partData =
    partDataId &&
    state.pyp?.partData?.byId?.[partDataId] &&
    state.pyp.partData.byId[partDataId].data
  if (partData) {
    // Try partTitle first (for some part types), then fall back to title
    if (partData.partTitle && Array.isArray(partData.partTitle) && partData.partTitle.length > 0) {
      metadata = partData.partTitle[0]
    } else if (partData.title && Array.isArray(partData.title) && partData.title.length > 0) {
      metadata = partData.title[0]
    }
    constraints = partData.constraints || []
  }
  if (currentPart && currentPart.name === "Action Plan Constraints")
    calender = true

  return {
    ...props,
    calender,
    pyp: state.pyp,
    currentPart,
    partDataId,
    metadata,
    initializedPart: state.pyp.initializedPart,
    fetchingPartData: state.pyp.fetchingPartData,
    initializingPYPInputs: state.pyp.initializingPYPInputs,
    constraints
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(
  class LayoutMetaDataConstraints extends React.Component {
    constructor(props) {
      super(props)
      // Convert date format for calendar inputs
      const convertDateForInput = (dateString) => {
        if (!dateString) return null
        const parsed = dayjs(dateString, ["YYYY:MM:DD", "YYYY-MM-DD", "YYYY/MM/DD", "MM/DD/YYYY", "DD-MM-YYYY"], true)
        if (parsed.isValid()) {
          return parsed.format("YYYY-MM-DD")
        }
        const autoParsed = dayjs(dateString)
        if (autoParsed.isValid()) {
          return autoParsed.format("YYYY-MM-DD")
        }
        return dateString
      }

      this.state = {
        startingConstraint:
          this.props.constraints &&
          this.props.constraints[0] &&
          this.props.constraints[0].text
            ? (this.props.calender ? convertDateForInput(this.props.constraints[0].text) : this.props.constraints[0].text)
            : null,
        endingConstraint:
          this.props.constraints &&
          this.props.constraints[1] &&
          this.props.constraints[1].text
            ? (this.props.calender ? convertDateForInput(this.props.constraints[1].text) : this.props.constraints[1].text)
            : null,
        loaded: false
      }
      this.updateTimeConstraints = this.updateTimeConstraints.bind(this)
      this.convertAMPM = this.convertAMPM.bind(this)
      this.reconvertAMPM = this.reconvertAMPM.bind(this)
    }

    componentDidMount() {
      if (!this.props.pyp.savingPYP) {
        this.props.fetchPartData().then(() => this.setState({ loaded: true }))
      }
    }

    // Convert date format from YYYY:MM:DD or YYYY-MM-DD to YYYY-MM-DD for HTML date input
    convertDateForInput = (dateString) => {
      if (!dateString) return null
      // Try parsing with multiple formats
      const parsed = dayjs(dateString, ["YYYY:MM:DD", "YYYY-MM-DD", "YYYY/MM/DD", "MM/DD/YYYY", "DD-MM-YYYY"], true)
      if (parsed.isValid()) {
        return parsed.format("YYYY-MM-DD")
      }
      // If strict parsing fails, try auto-detection
      const autoParsed = dayjs(dateString)
      if (autoParsed.isValid()) {
        return autoParsed.format("YYYY-MM-DD")
      }
      return dateString // Return as-is if can't parse
    }

    componentDidUpdate(prevProps, prevState) {
      if (prevProps.pyp.savingPYP && !this.props.pyp.savingPYP) {
        this.props.fetchPartData().then(() => this.setState({ loaded: true }))
      }
      if (
        !prevState.startingConstraint &&
        !this.state.startingConstraint &&
        this.props.constraints &&
        Array.isArray(this.props.constraints) &&
        this.props.constraints.length > 0 &&
        this.props.constraints[0]
      ) {
        const startConstraint = this.props.constraints[0].text
        const endConstraint = this.props.constraints[1]?.text || null
        
        this.setState({
          startingConstraint: this.props.calender ? this.convertDateForInput(startConstraint) : startConstraint,
          endingConstraint: this.props.calender && endConstraint ? this.convertDateForInput(endConstraint) : endConstraint,
          loaded: true
        })
      }
    }

    convertAMPM = (time, AMorPM) => {
      let convertedTime = ""
      AMorPM === "am"
        ? (convertedTime = `0${time.split("am")[0]}`)
        : (convertedTime = `${
            parseInt(time.split("pm")[0].split(":")[0]) + 12
          }:${time.split("pm")[0].split(":")[1]}`)
      if (convertedTime.length === 6) convertedTime = convertedTime.substr(1)
      if (convertedTime.length > 5)
        convertedTime =
          AMorPM === "am"
            ? convertedTime.split("pm")[0].substr(1)
            : `${parseInt(convertedTime.split("am")[0].split(":")[0])}:${
                convertedTime.split("am")[0].split(":")[1]
              }`
      return convertedTime
    }

    reconvertAMPM = (time, AMorPM) => {
      let convertedTime = ""
      AMorPM === "am"
        ? (convertedTime = `${parseInt(time.split(":")[0])}:${
            time.split(":")[1]
          }${parseInt(time.split(":")[0]) === 12 ? "pm" : "am"}`)
        : (convertedTime = `${parseInt(time.split(":")[0]) - 12}:${
            time.split(":")[1]
          }${parseInt(time.split(":")[0]) === 24 ? "am" : "pm"}`)
      return convertedTime
    }

    // Convert date from YYYY-MM-DD (HTML input) to YYYY:MM:DD (database format) for saving
    convertDateForSave = (dateString) => {
      if (!dateString) return null
      if (!this.props.calender) return dateString // Not a date, return as-is
      // HTML date input returns YYYY-MM-DD, convert to YYYY:MM:DD for database
      const parsed = dayjs(dateString, ["YYYY-MM-DD", "YYYY:MM:DD", "YYYY/MM/DD"], true)
      if (parsed.isValid()) {
        return parsed.format("YYYY:MM:DD")
      }
      return dateString // Return as-is if can't parse
    }

    updateTimeConstraints = (value, AMorPM) => {
      let constraint1 = this.state.startingConstraint
      let constraint2 = this.state.endingConstraint
      
      if (AMorPM === "am") {
        constraint1 = this.props.calender ? value : this.convertAMPM(value, "am")
      } else {
        constraint2 = this.props.calender ? value : this.convertAMPM(value, "pm")
      }

      this.setState({
        startingConstraint: constraint1,
        endingConstraint: constraint2
      })
      
      if (constraint1 && constraint2) {
        // Convert dates to database format before saving
        const saveConstraint1 = this.props.calender ? this.convertDateForSave(constraint1) : constraint1
        const saveConstraint2 = this.props.calender ? this.convertDateForSave(constraint2) : constraint2
        this.props.storeTimeConstraints({ constraint1: saveConstraint1, constraint2: saveConstraint2 })
      }
    }

    render() {
      return (
        <PYPLayoutContainer
          backgroundColor={colors.background}
          style={{ ...this.props.style, ...styles.layoutContainer }}
        >
          <PYPPartTitleContent
            title={this.props.metadata.title}
            description={this.props.metadata.description}
          />
          <div style={styles.constraintsContainer}>
            {" "}
            <div style={{
              ...styles.startingConstraint,
              width: this.props.calender ? "350px" : styles.startingConstraint.width
            }}>
              <TimeConstraintSelector
                title={
                  this.props.calender
                    ? "When do you plan to finish PYP? (MM/DD/YYYY)"
                    : "What time do you wake up?"
                }
                AMorPM="am"
                updateTimeConstraints={this.updateTimeConstraints}
                value={
                  this.state.startingConstraint
                    ? this.props.calender
                      ? this.state.startingConstraint
                      : this.reconvertAMPM(this.state.startingConstraint, "am")
                    : null
                }
                loaded={this.state.loaded}
                calender={this.props.calender}
              />
            </div>
            <div style={{
              ...styles.endingConstraint,
              width: this.props.calender ? "370px" : styles.endingConstraint.width
            }}>
              <TimeConstraintSelector
                value={
                  this.state.endingConstraint
                    ? this.props.calender
                      ? this.state.endingConstraint
                      : this.reconvertAMPM(this.state.endingConstraint, "pm")
                    : null
                }
                title={
                  this.props.calender
                    ? "When do you want to begin your next chapter? (MM/DD/YYYY)"
                    : "What time do you go to bed?"
                }
                AMorPM="pm"
                updateTimeConstraints={this.updateTimeConstraints}
                loaded={this.state.loaded}
                calender={this.props.calender}
              />
            </div>
          </div>
        </PYPLayoutContainer>
      )
    }
  }
)
